enum UserApplication {
  workspace = 'workspace_dashboard',
  investor = 'investor_dashboard',
}

export default UserApplication
